import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: 'Poppins', sans-serif;
  }

  body {
    background-color: #f8f9fa;
    color: #222;
  }

  h1, h2, h3 {
    font-weight: 600;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  body.no-scroll {
      overflow: hidden;
  }
`;
